export const getInitialState = () => ({
    fetchStatus: "initial",
    rebookPolicy: undefined,
    error: undefined
});
